module.exports = __webpack_public_path__ + "fbf8cf493677a6da3b07c88d6951fa44.svg";